import React, { useContext, useEffect, useState } from 'react';
import { AppBar, useLogout } from 'react-admin';

import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import useMediaQuery from '@material-ui/core/useMediaQuery';

import Context from '../../context';
import { APP_VERSION } from '../../utils';
import UserMenu from '../UserMenu';

const useStyles = makeStyles({
  title: {
    flex: 1,
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
  },
});

const AppBarCustom = (props) => {
  const classes = useStyles();
  const celular = useMediaQuery((tema) => tema.breakpoints.down('sm'));
  const logout = useLogout();

  const [total, setTotal] = useContext(Context);
  // O react-admin põe o título da tela dentro do texto da barra; sem título, sem o traço final.
  const [temTitulo, setTemTitulo] = useState(false);

  useEffect(() => {
    const alvo = document.getElementById('react-admin-title');
    if (!alvo) return undefined;
    const observador = new MutationObserver(() =>
      setTemTitulo(alvo.childNodes.length > 1),
    );
    observador.observe(alvo, { childList: true });
    return () => observador.disconnect();
  }, []);

  useEffect(() => {
    if (total) {
      setTotal(0);
      logout2();
    }
  }, [total]);

  function logout2() {
    logout();
  }

  return (
    <>
      <AppBar {...props} userMenu={<UserMenu />} elevation={1}>
        <Typography
          variant="h6"
          color="inherit"
          className={classes.title}
          id="react-admin-title"
        >
          {`${celular ? 'MG' : 'Módulo Gerencial'} - ${APP_VERSION}${
            temTitulo ? ' - ' : ''
          }`}
        </Typography>
      </AppBar>
    </>
  );
};

export default AppBarCustom;
